import { CommonService } from './../../services/common.service';
import { Component, OnInit } from '@angular/core';
import { TenantLicenseSummary } from '../../models/azure-dashboard-view.model';
import { Router, ActivatedRoute } from '@angular/router';
import { ReportingService } from '../../services/reporting.service';
import { FileService } from '../../services/file.service';
import { NgProgress } from 'ngx-progressbar';
import { Sort } from '@angular/material/sort';
import { TablefilterMultiplePipe } from '../../shared/pipes/tablefilter-multiple.pipe';
import { AuthService } from '../../services/auth.service';
import { CurrentUserModel } from '../../models/account-ledger.model';
import { NgProgressService } from '../../services/ngProgress.service';

@Component({
  selector: 'app-license-reporting-dashboard',
  templateUrl: './license-reporting-dashboard.component.html',
  styleUrls: ['./license-reporting-dashboard.component.css']
})
export class LicenseReportingDashboardComponent implements OnInit {

  title = 'License Usage Reports';

  loadContent = false;
  searchField = '';
  filterResultArr: any;
  hasEmptyFilterResult: boolean = false;
  accountId: string = '';

  licenseReports: TenantLicenseSummary[] = [];
  sortedData: TenantLicenseSummary[] = [];

   //export excel
   url: string;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private reportingService: ReportingService,
    private commonService: CommonService,
    private fileService: FileService,
    private authService: AuthService,
    private ngProgress: NgProgressService
  ) { }

  ngOnInit() {
    
    this.ngProgress.start();
    this.loadContent = false;

    this.authService.getLoginInfo()
    .subscribe((res: CurrentUserModel) => {
      this.accountId = res.accountId;
    }, 
    (error: any) => {
      console.info(error);
    });

    this.getLicenseReports();

    this.ngProgress.done();

  }

  getLicenseReports() {
      this.reportingService.getLicenseReportSummary().subscribe((value: TenantLicenseSummary[]) => {
          this.licenseReports = value;
          this.sortedData = this.licenseReports.slice();
      },
      (error: any) => {
        console.info(error);
      });
  }

  onLoading(currentLoadingStatus: boolean) {
   
    this.loadContent = !currentLoadingStatus;
  }

  exportLicenseReports() {
    this.ngProgress.start();
    this.commonService.implementToast('License usage report will be downloaded shortly', 'Info');
    this.reportingService.exportLicenseDeploymentReportExcel().subscribe((data:any) => {
      
      const fileName = `LicenseDeployment-${this.accountId}.xlsx`;

      this.fileService.saveAsExcelFile(data, fileName);
      this.ngProgress.done();
      this.commonService.implementToast('License usage report downloaded successfully', 'Success');
    }, 
    (error: any) => {
      console.info(error);
      this.ngProgress.done();
    });
  }
 

  close() {
    this.router.navigateByUrl('/reporting');
  }

  sortData(sort: Sort) {
    let data = this.licenseReports.slice();

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'tenantName': return compare(a.tenantName.toLowerCase(), b.tenantName.toLowerCase(), isAsc);
        case 'tenantId': return compare(a.tenantId.toLowerCase(), b.tenantId.toLowerCase(), isAsc);
        case 'productName': return compare(a.productName.toLowerCase(), b.productName.toLowerCase(), isAsc);
        case 'domain': return compare(a.domain.toLowerCase(), b.domain.toLowerCase(), isAsc);
        case 'activeLicenses': return compare(parseInt(a.activeLicenses), parseInt(b.activeLicenses), isAsc);
        case 'consumedLicense': return compare(parseInt(a.consumedLicense), parseInt(b.consumedLicense), isAsc);
        case 'availableLicenses': return compare(parseInt(a.availableLicenses), parseInt(b.availableLicenses), isAsc);
        default: return 0;
      }
    });
  }

  onChange() {
    this.filterResultArr = new TablefilterMultiplePipe().transform(this.sortedData, ['tenantName', 'domain', 'productName'], this.searchField);
    if (this.filterResultArr.length === 0 && this.searchField !=='') {
      this.hasEmptyFilterResult = true;

    } else {
      this.hasEmptyFilterResult = false;
    }
  }

  filterReset() {
    this.searchField = "";
    this.hasEmptyFilterResult = false;
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

